<script>
import variables from '@/styles/variables.scss'
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  variables () {
    return variables
  },
  render (h, context) {
    const { icon, title } = context.props
    const color = 'color:' + variables.menuText
    const vnodes = []

    if (icon) {
      vnodes.push(<svg-icon style={color} icon-class={icon}/>)
    }

    if (title) {
      vnodes.push(<span slot='title'>{(title)}</span>)
    }
    return vnodes
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/Item.vue